import { ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}

export default function Modal({ isOpen, onClose, title, children, footer }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 transition-opacity bg-secondary-900/75 dark:bg-black/80"
          onClick={onClose}
        />

        {/* Modal panel */}
        <div className="inline-block w-full max-w-lg my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-secondary-800 rounded-lg shadow-xl">
          <div className="flex items-center justify-between px-6 py-4 border-b border-secondary-200 dark:border-secondary-700">
            <h3 className="text-lg font-semibold text-secondary-900 dark:text-secondary-100">{title}</h3>
            <button
              onClick={onClose}
              className="p-1 rounded-md text-secondary-400 dark:text-secondary-500 hover:bg-secondary-100 dark:hover:bg-secondary-700"
            >
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="px-6 py-4 text-secondary-900 dark:text-secondary-100">{children}</div>
          {footer && (
            <div className="flex justify-end gap-3 px-6 py-4 border-t border-secondary-200 dark:border-secondary-700 bg-secondary-50 dark:bg-secondary-900/50">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
